import React, { FC } from 'react';
import { useHistory } from 'react-router';

import { useIsAdmin } from '@app/hooks/use-is-admin';
import { useApi, useFetchData } from '@app/hooks';
import { User } from '@app/api/models';

import Error404 from '../../pages/errors/404';
import { useColumns } from './columns';
import { QueryTable } from '../common/table';

const UsersTable: FC = () => {
  const history = useHistory();
  const isAdmin = useIsAdmin();

  const columns = useColumns();
  const api = useApi();
  const [fetchData] = useFetchData<User>({ method: api.users.getUsers });

  if (!isAdmin) {
    return <Error404 />;
  }

  return (
    <>
      <QueryTable<User>
        title="Пользователи"
        fetchData={fetchData}
        columns={columns}
        onCreateClick={() => history.push('/users/create')}
      />
    </>
  );
};

export default UsersTable;
